export default __webpack_public_path__ + "static/media/unlocked.6e68d19d.svg";